<mat-expansion-panel
  *ngIf="!showErrorsOnly || (showErrorsOnly && error)"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [ngClass]="{'error-accordion': error}"
  class="log-entry"
  hideToggle>

  <mat-expansion-panel-header *ngIf="!data.message" fxLayout="row" fxFlexFill>

    <mat-panel-title *ngIf="!data.message" fxFlex="90%">
      <span [innerHTML]="rendered | safe: 'html'"></span>
    </mat-panel-title>

    <mat-panel-description fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="6px" fxFlex="10%">
      <mat-icon [ngClass]="{'error': error, 'success': !error}">{{statusIcon}}</mat-icon>
    </mat-panel-description>

  </mat-expansion-panel-header>

  <mat-expansion-panel-header *ngIf="data.message">
    <div>
      {{data.message}}
    </div>
  </mat-expansion-panel-header>

  <div fxLayout="column">

    <div *ngIf="!data.message" fxLayout="column" fxLayoutGap="6px">

      <div [ngClass]="{'error': error}" fxLayoutAlign="start center" fxLayoutGap="6px">
        <mat-icon>{{statusIcon}}</mat-icon>
        <span *ngIf="data.code">({{_parseErrorCode(data)}})</span>
        <span *ngIf="!data.code">(SUCCESS)</span>
      </div>

    </div>

    <div *ngIf="debug" class="debug">{{data | json}}</div>
  </div>

</mat-expansion-panel>
